<HomeNavBar/>
<section class="board-page">
  <!-- <p>{{buckets}}</p> -->
  <div class="container-fluid px-0">
    <div class="row content-section g-0">
      <div v-if="portals_open"
  class="col-lg-3 d-none d-lg-flex shadow-sm px-2">
        <AllPortals />
      </div>
       <div :class="portals_open ? 'col-xl-9 col-lg-12' : 'col-12'" class="p-0 padpro-screen scrollable-container board-workspace rounded pb-5">
        <div class="">

  <!-- Mobile Only Back Button -->


 <div class="board-toolbar d-flex align-items-center justify-content-between">
    <div class="board-toolbar-main d-flex align-items-center min-w-0">
 <button
  class="btn btn-light board-icon-btn d-none d-xl-flex align-items-center justify-content-center me-2"
  @click="portals_open = !portals_open"
  title="Toggle Portals"
>
  <i :class="portals_open ? 'bi-arrows-angle-expand' : 'bi-arrows-angle-contract'"></i>
</button>
  <button
      class="btn btn-light board-icon-btn d-inline-flex align-items-center justify-content-center me-2"
      @click="goBack"
      title="Back"
      aria-label="Back"
  >
    <i class="bi bi-chevron-left"></i>
  </button>
   <div class="board-title-wrap min-w-0 ms-1">
    <h5 class="board-title fw-bold text-dark mb-0 text-truncate">{{ $route.params.board_name }}</h5>
  </div>
</div>

  <div class="position-relative me-1" ref="filterDropdownRef">
    <button
      class="btn btn-light board-icon-btn d-inline-flex align-items-center justify-content-center position-relative"
      @click="filterDropdownOpen = !filterDropdownOpen" title="Filter tasks">
      <i class="bi bi-funnel-fill"></i>
      <span v-if="activeFilterCount > 0"
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
        {{ activeFilterCount }}
      </span>
    </button>

    <div
  v-if="filterDropdownOpen"
  class="task-filter-dropdown position-absolute top-100 end-0 bg-white shadow rounded-3 mt-2"
>
  <div class="task-filter-header">
    <div>
      <p class="fw-bold text-dark text-sm mb-0">Filter Tasks</p>
      <span class="text-muted text-xxs">Narrow this board by task, member, or status</span>
    </div>
    <div class="d-flex gap-2 align-items-center flex-shrink-0">
      <button v-if="activeFilterCount > 0" class="btn btn-link btn-sm text-danger p-0 text-xs fw-semibold" @click="clearAllFilters">
        Clear all
      </button>
      <button class="btn btn-sm btn-light task-filter-close" @click="filterDropdownOpen = false">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>

  <div class="task-filter-body">
  <div class="task-filter-section">
    <label class="task-filter-label">Search</label>
    <div class="input-group input-group-sm task-filter-search">
      <span class="input-group-text"><i class="bi bi-search text-muted"></i></span>
      <input
        v-model="filters.search"
        type="text"
        class="form-control text-xs"
        placeholder="Search tasks, users, statuses..."
      />
    </div>
  </div>

  <div class="task-filter-section">
    <label class="task-filter-label">Assigned To</label>
    <div class="task-filter-chip-list">
      <button
        v-for="member in (showAllMembers ? members : members.slice(0, 5))"
        :key="member.id"
        @click="toggleUserFilter(member.id)"
        type="button"
        class="task-filter-chip"
         :class="filters.users.includes(member.id) ? 'member-active' : 'status-inactive'"
      >
        <span class="task-filter-chip-avatar">{{ get_member_initials(member) }}</span>
        {{ member.full_name || member.username || member.name }}
      </button>
    </div>
    <p v-if="!members.length" class="task-filter-empty">No members available</p>
    <button 
      v-if="members.length > 5" 
      class="btn btn-link btn-sm text-decoration-none text-xs p-0 mt-2 fw-semibold" 
      @click="showAllMembers = !showAllMembers"
    >
      {{ showAllMembers ? 'See less' : `See more (${members.length - 5})` }}
    </button>
  </div>

  <div class="task-filter-section">
    <label class="task-filter-label">Status</label>
    <div class="task-filter-chip-list">
      <button
        v-for="status in (showAllStatuses ? availableStatuses : availableStatuses.slice(0, 5))"
        :key="status.id"
        @click="toggleStatusFilter(status.id)"
        type="button"
        class="task-filter-chip"
        :class="[status_chip_class(status), filters.statuses.includes(status.id) ? 'status-active' : 'status-inactive']"
      >
        <i class="bi bi-circle-fill task-filter-chip-dot"></i>
        {{ format_label(status.task_name || status.label || status.name) }}
      </button>
    </div>
    <p v-if="!availableStatuses.length" class="task-filter-empty">No statuses available</p>
    <button 
      v-if="availableStatuses.length > 5" 
      class="btn btn-link btn-sm text-decoration-none text-xs p-0 mt-2 fw-semibold" 
      @click="showAllStatuses = !showAllStatuses"
    >
      {{ showAllStatuses ? 'See less' : `See more (${availableStatuses.length - 5})` }}
    </button>
  </div>

  <div v-if="activeFilterCount > 0" class="task-filter-summary">
    <span class="text-xs text-muted">
      Showing <strong class="text-primary">{{ filteredTaskCount }}</strong> matching tasks
    </span>
  </div>
  </div>
</div>
  </div>
</div>

</div>

  <div class="p-1">
    <div class="board-columns-scroll d-flex gap-3 overflow-auto h-100 w-100">
      <template v-if="board_loading">
      <div
        v-for="n in 4"
        :key="n"
        class="skeleton-column"
      >
        <div class="skeleton-header"></div>
        <div v-for="m in 4" :key="m" class="skeleton-task"></div>
      </div>
    </template>
    <template v-else>

  <draggable
  v-model="buckets"
  item-key="id"
  class="d-flex flex-row gap-1 board-columns-draggable"
  handle=".drag-handle"
  :delay="200"
  :delay-on-touch-only="true"
  :touch-start-threshold="10"
  @change="on_column_drag_change"
>
  <template #item="{ element, index }">
    <div class="board-column-slot">
      <!-- <p>{{ element }}</p> -->
      <Column
        :key="element.id"
        :bucket="element"
        :buckets="buckets"
        :members="members"
        :statuses="availableStatuses"
        :priorities="availablePriorities"
        :filters="filters"
        :can_manage_task_statuses="can_manage_task_statuses"
        @delete-bucket="deleteBucket(index)"
        @statuses-updated="fetch_task_statuses"
        @priorities-updated="fetch_priority_statuses"
      />
    </div>
  </template>
</draggable>

      <div class="board-add-column-card" v-if="isAddingBucket">
          <input
            v-model="newBucketTitle"
            class="form-control form-control-sm border-bottom text-xxs"
            ref="newBucketInput"
            @keydown.enter="add_new_column"
            placeholder="Enter column name"
          />
      </div>

      <!-- Add Button -->
      <div class="board-add-column-card board-add-column-empty d-flex align-items-start" v-else>
        <button type="button" class="btn btn-light w-100 text-start text-xs fw-semibold" @click="startAddingBucket">
          <i class="bi bi-plus-lg me-1"></i> Add a new column
        </button>
      </div>
      </template>

    </div>
  </div>

    </div>
    </div>
</div>
</section>
